import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
    OrderGuideServiceProxy,
    FieldTypes,
    UserGroupDto,
    PagedResultDtoOfUserGroupDto
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

import { SearchAndSelectComponent } from '@app/shared/common/shop-system/common/search-and-select/search-and-select.component';
import { ColumnDefinition } from '@app/shared/common/shop-system/models/models';

@Component({
    selector: 'app-shop-search-and-select-user-groups',
    templateUrl: './search-and-select-user-groups.component.html',
    styleUrls: ['./search-and-select-user-groups.component.css']
})
export class SearchAndSelectUserGroupsComponent extends AppComponentBase implements OnInit {

    //#region initialization Basic SearchAndSelectComponent
    //create dynamic SearchAndSelectComponent depends on Provided type
    private _searchAndSelectUserGroup: SearchAndSelectComponent<UserGroupDto>;
    @ViewChild('appSearchAndSelectComponent')
    set searchAndSelectArticle(value: SearchAndSelectComponent<UserGroupDto>) {
        this._searchAndSelectUserGroup = value;
        //set instance of class to define which property he need s to show
        this._searchAndSelectUserGroup.instance = UserGroupDto.fromJS({});
        //set specific property to show that overrides default columns depends on instance of provided Class(Type)

        let columns: ColumnDefinition[] = [
            { field: 'name', header: 'Name', sorting: true, type: FieldTypes.Text }
        ];
        this._searchAndSelectUserGroup.columns = columns;
    }
    //#endregion

    @Input() orderGuideId: string;

    @Output() onChangeUserGroups: EventEmitter<any> = new EventEmitter<any>();

    selectedUserGroups: UserGroupDto[] = [];

    private _userGroups: UserGroupDto[] = [];
    set userGroups(value: UserGroupDto[]) {
        if (!value) {
            this._userGroups = [];
        }

        this._userGroups = value;
    }
    get userGroups(): UserGroupDto[] {
        return this._userGroups;
    }

    private _total = 0;
    set total(value: number) {
        if (!value) {
            this._total = 0;
        }

        this._total = value;
    }
    get total(): number {
        return this._total;
    }

    private _searchString: string;
    set searchString(value: string) {
        this._searchString = value;
    }
    get searchString(): string {
        return this._searchString;
    }

    get excludeOrderGuideId(): string {
        return this.orderGuideId;
    }

    id: string;

    constructor(
        injector: Injector,
        private _orderGuideServiceProxy: OrderGuideServiceProxy,
        private _activatedRoute: ActivatedRoute
    ) {
        super(injector);


        this.id = this._activatedRoute.snapshot.params['id'];
    }

    ngOnInit(): void {
        this.getUserGroups();
    }

    onSearchChange(searchString: string) {
        this.searchString = searchString;
        this.getUserGroups();
    }

    getUserGroups() {
        if (this._searchAndSelectUserGroup) {
            this._searchAndSelectUserGroup.primengTableHelper.showLoadingIndicator();
            this._orderGuideServiceProxy.getAvailableUserGroupsForOrderGuide(
                    this.searchString || undefined,
                    this.excludeOrderGuideId || this.id || undefined,
                    undefined, 0, 10)
                .subscribe((userGroups: PagedResultDtoOfUserGroupDto) => {
                    this.userGroups = userGroups.items;
                    this.total = userGroups.totalCount;
                    this._searchAndSelectUserGroup.primengTableHelper.hideLoadingIndicator();
                });
        }
    }

    onPagination(pagination) {
        if (this._searchAndSelectUserGroup) {
            this._searchAndSelectUserGroup.primengTableHelper.showLoadingIndicator();
            this._orderGuideServiceProxy.getAvailableUserGroupsForOrderGuide(
                    this.searchString || undefined,
                    this.excludeOrderGuideId || this.id || undefined,
                    pagination.sorting || undefined,
                    pagination.skipCount || 0,
                    pagination.maxResultCount || 10)
                .subscribe((userGroups: PagedResultDtoOfUserGroupDto) => {
                    this.userGroups = userGroups.items;
                    this.total = userGroups.totalCount;
                    this._searchAndSelectUserGroup.primengTableHelper.hideLoadingIndicator();
                });
        }
    }

    onRowSelect($event) {
        this.onChangeUserGroups.emit($event);
    }
    onRowUnselect($event) {
        this.onChangeUserGroups.emit($event);
    }
}
